import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Icon
} from 'semantic-ui-react';

import styles from '../../document-modal.module.css';

const CollectionLabelActions = ( {
	deletable = true,
	editable = true,
	onDelete,
	onEdit,
	id
} ) => {
	const handleEdit = useCallback( () => onEdit( id ), [
		onEdit,
		id
	] );

	const handleDelete = useCallback( () => onDelete( id ), [
		onDelete,
		id
	] );

	return (
		<div className={ styles.collectionLabelActions }>
			{ editable
				? <Button
					icon
					color="pink"
					size="tiny"
					onClick={ handleEdit }
				>
					<Icon name="pencil" />
				</Button>
				: null
			}
			{ deletable
				? <Button
					icon
					negative
					size="tiny"
					onClick={ handleDelete }
				>
					<Icon name="trash" />
				</Button>
				: null
			}
		</div>
	);
};

CollectionLabelActions.propTypes = {
	deletable: PropTypes.bool,
	editable: PropTypes.bool,
	onDelete: PropTypes.func.isRequired,
	onEdit: PropTypes.func.isRequired,
	id: PropTypes.number.isRequired
};

export default CollectionLabelActions;
